import { render } from "./situacion-financiera.vue?vue&type=template&id=51d77e7a&scoped=true"
import script from "./situacion-financiera.vue?vue&type=script&lang=js"
export * from "./situacion-financiera.vue?vue&type=script&lang=js"

import "./situacion-financiera.vue?vue&type=style&index=0&id=51d77e7a&scoped=true&lang=css"
import "./situacion-financiera.vue?vue&type=style&index=1&id=51d77e7a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51d77e7a"]])

export default __exports__